import { render, staticRenderFns } from "./Box2.vue?vue&type=template&id=39d394f9&scoped=true"
import script from "./Box2.vue?vue&type=script&lang=js"
export * from "./Box2.vue?vue&type=script&lang=js"
import style0 from "./Box2.vue?vue&type=style&index=0&id=39d394f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d394f9",
  null
  
)

export default component.exports